import { Mediator, app } from "modular-openscriptjs";
import { eParse, inform, processStart, processEnd } from "../helpers";
import { dc, STRINGS } from "../declarations";

const $e = app("$e");

export class Payment extends Mediator {
	$$payment = {
		completed: (ed, event) => {
			this.handleAfterPayment(ed);
		},

		failed: (ed, event) => {
			this.handlePaymentFailure(ed, event);
		},

		needs: {
			creation: (ed, event) => {
				this.createPayment(ed, event);
			},
			collection: (ed, event) => {
				let data = eParse(ed);
				let currency = data.message.get("currency", dc.userCurrency);
				let amount = data.message.get("amount", 0);
				app("router").to(`payments.collect`, {
					...data.meta.getAll(),
					amount,
					currency,
				});
			},
		},

		has: {
			processingError: (ed, event) => {
				processEnd();
			},
		},
	};

	async createPayment(ed, event) {
		let data = eParse(ed);

		let message = data.message;
		let meta = data.meta;

		processStart();

		if (!message.tc) {
			inform("Please accept the terms and conditions", STRINGS.ERROR);

			processEnd();

			return this.broadcast($e.payment.has.processingError, ed);
		} else {
			localStorage.setItem("paymentTc", 1);
		}

		if (!(meta.has("type") && meta.has("typeId") && meta.has("route"))) {
			inform(
				"Payment URL is malformed. Please start the payment process over",
				STRINGS.ERROR
			);

			return app("router").to("/");
		}

		this.broadcast(this.eventFromName(message.method), ed);
	}

	async handleAfterPayment(ed, event) {
		let data = eParse(ed);

		inform(`Payment completed successfully`, STRINGS.SUCCESS);

		processEnd();

		let next = data.meta.get("next") ?? app("router").qs.get("next");

		if (next) {
			app("router").to(next);
		}
	}

	async handlePaymentFailure(ed, event) {
		inform(`The payment did not complete successfully`, STRINGS.ERROR);

		this.send($e.payment.needs.collection, ed);
	}

	eventFromName(name) {
		return `payment:method:${name}:process`;
	}
}
